import React, { useState } from 'react';
import { useGlobalContext } from '@honeycomb/data';
import { BellIcon, Container, Fade, Notification2, TypographyBody } from '@honeycomb/ui-core';
export function NightsAdjustedNotification({ message }) {
    const [open, setOpen] = useState(true);
    const [exited, setExited] = useState(false); // Track when the fade animation has completed.
    const { resourceStrings: { EXTENDEDFLIGHTSELECTIONNIGHTSNOTIFICATIONTEXT }, } = useGlobalContext();
    if (!open && exited) {
        return null;
    }
    return (React.createElement(Container, { my: { xs: 3, l: 4 } },
        React.createElement(Fade, { in: open, onExited: () => {
                setExited(true);
            } },
            React.createElement(Notification2, { "data-id": "night_adjusted_notification", color: "highlight", onDismiss: () => {
                    setOpen(false);
                }, icon: React.createElement(BellIcon, null) },
                React.createElement(TypographyBody, null, message !== null && message !== void 0 ? message : EXTENDEDFLIGHTSELECTIONNIGHTSNOTIFICATIONTEXT)))));
}
